export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";